{
    "v": "5.9.6",
    "fr": 25,
    "ip": 0,
    "op": 37,
    "w": 500,
    "h": 500,
    "nm": "9 Add User",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 7,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "plus",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [166.563, 161.525, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [366.563, 361.525, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [0, 33.14],
                                                    [0, -33.14]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 7,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [0.581, 30.728],
                                                    [0.581, -30.889]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [0, 33.14],
                                                    [0, -33.14]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ind": 1,
                            "ty": "sh",
                            "ix": 2,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-33.14, 0],
                                                    [33.14, 0]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 7,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-30.228, -0.081],
                                                    [31.389, -0.081]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-33.14, 0],
                                                    [33.14, 0]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 2",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.129, 0.345, 0.875, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [366.563, 361.525], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -39.889],
                                                    [39.889, 0],
                                                    [0, 39.889],
                                                    [-39.889, 0]
                                                ],
                                                "o": [
                                                    [0, 39.889],
                                                    [-39.889, 0],
                                                    [0, -39.889],
                                                    [39.889, 0]
                                                ],
                                                "v": [
                                                    [72.225, 0],
                                                    [0, 72.225],
                                                    [-72.225, 0],
                                                    [0, -72.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 7,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -37.083],
                                                    [37.083, 0],
                                                    [0, 37.083],
                                                    [-37.083, 0]
                                                ],
                                                "o": [
                                                    [0, 37.083],
                                                    [-37.083, 0],
                                                    [0, -37.083],
                                                    [37.083, 0]
                                                ],
                                                "v": [
                                                    [67.725, -0.081],
                                                    [0.581, 67.063],
                                                    [-66.563, -0.081],
                                                    [0.581, -67.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -39.889],
                                                    [39.889, 0],
                                                    [0, 39.889],
                                                    [-39.889, 0]
                                                ],
                                                "o": [
                                                    [0, 39.889],
                                                    [-39.889, 0],
                                                    [0, -39.889],
                                                    [39.889, 0]
                                                ],
                                                "v": [
                                                    [72.225, 0],
                                                    [0, 72.225],
                                                    [-72.225, 0],
                                                    [0, -72.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.129, 0.345, 0.875, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [366.563, 361.525], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Mask",
            "parent": 1,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [166.563, 161.525, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [366.563, 361.525, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -39.889],
                                                    [39.889, 0],
                                                    [0, 39.889],
                                                    [-39.889, 0]
                                                ],
                                                "o": [
                                                    [0, 39.889],
                                                    [-39.889, 0],
                                                    [0, -39.889],
                                                    [39.889, 0]
                                                ],
                                                "v": [
                                                    [72.225, 0],
                                                    [0, 72.225],
                                                    [-72.225, 0],
                                                    [0, -72.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.667, "y": 1 },
                                        "o": { "x": 0.333, "y": 0 },
                                        "t": 7,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -37.083],
                                                    [37.083, 0],
                                                    [0, 37.083],
                                                    [-37.083, 0]
                                                ],
                                                "o": [
                                                    [0, 37.083],
                                                    [-37.083, 0],
                                                    [0, -37.083],
                                                    [37.083, 0]
                                                ],
                                                "v": [
                                                    [67.725, -0.081],
                                                    [0.581, 67.063],
                                                    [-66.563, -0.081],
                                                    [0.581, -67.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -39.889],
                                                    [39.889, 0],
                                                    [0, 39.889],
                                                    [-39.889, 0]
                                                ],
                                                "o": [
                                                    [0, 39.889],
                                                    [-39.889, 0],
                                                    [0, -39.889],
                                                    [39.889, 0]
                                                ],
                                                "v": [
                                                    [72.225, 0],
                                                    [0, 72.225],
                                                    [-72.225, 0],
                                                    [0, -72.225]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [366.563, 361.525], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "circle",
            "parent": 1,
            "tt": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [55.143, 19.363, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [255.143, 219.363, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -84.632],
                                        [84.712, 0],
                                        [0, 84.632],
                                        [-84.712, 0]
                                    ],
                                    "o": [
                                        [0, 84.632],
                                        [-84.712, 0],
                                        [0, -84.632],
                                        [84.712, 0]
                                    ],
                                    "v": [
                                        [153.384, 0],
                                        [0, 153.239],
                                        [-153.384, 0],
                                        [0, -153.239]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.047, 0.047, 0.047, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [255.143, 219.363], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Mask",
            "parent": 1,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [55.143, 19.363, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [255.143, 219.363, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 6,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -84.632],
                                                    [13.878, -22.638],
                                                    [36.017, -21.197],
                                                    [1.393, -0.862],
                                                    [15.097, 0],
                                                    [0, 84.632],
                                                    [-84.712, 0]
                                                ],
                                                "o": [
                                                    [0, 28.47],
                                                    [-0.216, 0.668],
                                                    [-23.24, 13.678],
                                                    [-12.215, 7.561],
                                                    [-84.712, 0],
                                                    [0, -84.632],
                                                    [84.712, 0]
                                                ],
                                                "v": [
                                                    [153.384, 0],
                                                    [132.073, 77.969],
                                                    [73.34, 85.835],
                                                    [43.464, 147],
                                                    [0, 153.239],
                                                    [-153.384, 0],
                                                    [0, -153.239]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, -84.632],
                                                    [13.878, -22.638],
                                                    [37.689, -18.057],
                                                    [1.393, -0.862],
                                                    [15.097, 0],
                                                    [0, 84.632],
                                                    [-84.712, 0]
                                                ],
                                                "o": [
                                                    [0, 28.47],
                                                    [-0.216, 0.668],
                                                    [-32.983, 15.803],
                                                    [-12.215, 7.561],
                                                    [-84.712, 0],
                                                    [0, -84.632],
                                                    [84.712, 0]
                                                ],
                                                "v": [
                                                    [153.384, 0],
                                                    [132.073, 77.969],
                                                    [73.34, 85.835],
                                                    [40.964, 147],
                                                    [0, 153.239],
                                                    [-153.384, 0],
                                                    [0, -153.239]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [255.143, 219.363], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "person",
            "parent": 1,
            "tt": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [55.143, 19.363, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [255.143, 219.363, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-14.788, -7.394],
                                                [0, 0],
                                                [-12.289, 6.144],
                                                [0, 0],
                                                [0, 16.533],
                                                [0, 0],
                                                [0, 0],
                                                [11.842, 16.578],
                                                [0, 0],
                                                [0, 0],
                                                [0, -18.231],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [12.289, 6.144],
                                                [0, 0],
                                                [14.788, -7.394],
                                                [0, 0],
                                                [0, 0],
                                                [-20.373, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-18.231, 0],
                                                [0, 0],
                                                [0, 16.533]
                                            ],
                                            "v": [
                                                [-23.219, 4.882],
                                                [-23.219, 4.882],
                                                [15.822, 4.882],
                                                [15.822, 4.882],
                                                [39.951, -34.16],
                                                [39.951, -63.927],
                                                [39.951, -63.927],
                                                [-11.383, -90.345],
                                                [-14.338, -94.482],
                                                [-14.338, -94.482],
                                                [-47.348, -61.472],
                                                [-47.348, -34.16]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 11.31],
                                                [0, 0],
                                                [11.31, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [11.31, 0],
                                                [0, 0],
                                                [0, -11.31],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [40.565, -21.957],
                                                [55.611, -21.957],
                                                [76.089, -42.436],
                                                [76.089, -43.462],
                                                [55.611, -63.941],
                                                [39.951, -63.927]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 2,
                                    "ty": "sh",
                                    "ix": 3,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0, -11.31],
                                                [0, 0],
                                                [-11.31, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-11.31, 0],
                                                [0, 0],
                                                [0, 11.31],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-47.439, -63.941],
                                                [-62.486, -63.941],
                                                [-82.964, -43.462],
                                                [-82.964, -42.436],
                                                [-62.486, -21.957],
                                                [-47.439, -21.957]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 3",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 3,
                                    "ty": "sh",
                                    "ix": 4,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-10.418, 0],
                                                [0, 0],
                                                [-7.97, 5.695],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [8.235, 6.38],
                                                [0, 0],
                                                [9.796, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-41.337, 41.758],
                                                [-32.611, 48.519],
                                                [-3.835, 58.361],
                                                [-3.835, 58.361],
                                                [23.481, 49.605],
                                                [34.462, 41.758]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 4",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 4,
                                    "ty": "sh",
                                    "ix": 5,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [8.23, -1.487],
                                                [0, 0],
                                                [1.857, -8.564],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-2.186, 8.072],
                                                [0, 0],
                                                [-8.624, 1.558],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-19.174, 7.406],
                                                [-24.276, 25.866],
                                                [-41.33, 41.517],
                                                [-61.102, 45.089],
                                                [-78.417, 61.812],
                                                [-85.499, 94.482],
                                                [-96.545, 140.816]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 5",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 5,
                                    "ty": "sh",
                                    "ix": 6,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-8.23, -1.487],
                                                [0, 0],
                                                [-8.751, -39.907],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [2.186, 8.072],
                                                [0, 0],
                                                [3.536, 0.639],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [12.105, 6.701],
                                                [17.401, 25.866],
                                                [34.455, 41.517],
                                                [54.227, 45.089],
                                                [85.499, 87.723],
                                                [98.955, 145.816]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 6",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.047, 0.047, 0.047, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('color')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [259.045, 252.684], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 7,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 15.388],
                                                [0, 0],
                                                [25.296, 0],
                                                [0, 0],
                                                [10.673, -7.115],
                                                [0, 0],
                                                [0, 0],
                                                [11.107, -8.558],
                                                [0, 0],
                                                [0, -12.213],
                                                [0, 0],
                                                [-15.065, -0.699]
                                            ],
                                            "o": [
                                                [15.274, -0.471],
                                                [0, 0],
                                                [0, -25.296],
                                                [0, 0],
                                                [-12.827, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-12.982, -5.299],
                                                [0, 0],
                                                [-9.674, 7.454],
                                                [0, 0],
                                                [0, 15.238],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [43.377, 37.102],
                                                [70.931, 8.7],
                                                [70.931, 8.7],
                                                [25.129, -37.102],
                                                [25.129, -37.102],
                                                [-10.912, -26.19],
                                                [-10.912, -26.19],
                                                [-16.679, -28.543],
                                                [-55.588, -23.279],
                                                [-55.588, -23.279],
                                                [-70.931, 7.91],
                                                [-70.931, 8.7],
                                                [-43.867, 37.071]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.129, 0.345, 0.875, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [255.038, 151.655], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 10,
                                        "s": [-51.962, 151.655],
                                        "to": [51.167, 0],
                                        "ti": [-51.167, 0]
                                    },
                                    { "t": 28, "s": [255.038, 151.655] }
                                ],
                                "ix": 2
                            },
                            "a": { "a": 0, "k": [255.038, 151.655], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.833], "y": [1] },
                                        "o": { "x": [0.167], "y": [0] },
                                        "t": 10,
                                        "s": [-20]
                                    },
                                    { "t": 28, "s": [0] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-14.788, -7.394],
                                                [0, 0],
                                                [-12.289, 6.144],
                                                [0, 0],
                                                [0, 16.533],
                                                [0, 0],
                                                [0, 0],
                                                [11.842, 16.578],
                                                [0, 0],
                                                [0, 0],
                                                [0, -18.231],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [12.289, 6.144],
                                                [0, 0],
                                                [14.788, -7.394],
                                                [0, 0],
                                                [0, 0],
                                                [-20.373, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-18.231, 0],
                                                [0, 0],
                                                [0, 16.533]
                                            ],
                                            "v": [
                                                [-23.219, 4.882],
                                                [-23.219, 4.882],
                                                [15.822, 4.882],
                                                [15.822, 4.882],
                                                [39.951, -34.16],
                                                [39.951, -63.927],
                                                [39.951, -63.927],
                                                [-11.383, -90.345],
                                                [-14.338, -94.482],
                                                [-14.338, -94.482],
                                                [-47.348, -61.472],
                                                [-47.348, -34.16]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0, 11.31],
                                                [0, 0],
                                                [11.31, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [11.31, 0],
                                                [0, 0],
                                                [0, -11.31],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [40.565, -21.957],
                                                [55.611, -21.957],
                                                [76.089, -42.436],
                                                [76.089, -43.462],
                                                [55.611, -63.941],
                                                [39.951, -63.927]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 2,
                                    "ty": "sh",
                                    "ix": 3,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0, -11.31],
                                                [0, 0],
                                                [-11.31, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-11.31, 0],
                                                [0, 0],
                                                [0, 11.31],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-47.439, -63.941],
                                                [-62.486, -63.941],
                                                [-82.964, -43.462],
                                                [-82.964, -42.436],
                                                [-62.486, -21.957],
                                                [-47.439, -21.957]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 3",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 3,
                                    "ty": "sh",
                                    "ix": 4,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-10.418, 0],
                                                [0, 0],
                                                [-7.97, 5.695],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [8.235, 6.38],
                                                [0, 0],
                                                [9.796, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-41.337, 41.758],
                                                [-32.611, 48.519],
                                                [-3.835, 58.361],
                                                [-3.835, 58.361],
                                                [23.481, 49.605],
                                                [34.462, 41.758]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 4",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 4,
                                    "ty": "sh",
                                    "ix": 5,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [8.23, -1.487],
                                                [0, 0],
                                                [1.857, -8.564],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-2.186, 8.072],
                                                [0, 0],
                                                [-8.624, 1.558],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-19.174, 7.406],
                                                [-24.276, 25.866],
                                                [-41.33, 41.517],
                                                [-61.102, 45.089],
                                                [-78.417, 61.812],
                                                [-85.499, 94.482],
                                                [-96.545, 140.816]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 5",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 5,
                                    "ty": "sh",
                                    "ix": 6,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-8.23, -1.487],
                                                [0, 0],
                                                [-8.751, -39.907],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [2.186, 8.072],
                                                [0, 0],
                                                [3.536, 0.639],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [12.105, 6.701],
                                                [17.401, 25.866],
                                                [34.455, 41.517],
                                                [54.227, 45.089],
                                                [85.499, 87.723],
                                                [98.955, 145.816]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 6",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.047, 0.047, 0.047, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('color')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [259.045, 252.684], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 7,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 15.388],
                                                [0, 0],
                                                [25.296, 0],
                                                [0, 0],
                                                [10.673, -7.115],
                                                [0, 0],
                                                [0, 0],
                                                [11.107, -8.558],
                                                [0, 0],
                                                [0, -12.213],
                                                [0, 0],
                                                [-15.065, -0.699]
                                            ],
                                            "o": [
                                                [15.274, -0.471],
                                                [0, 0],
                                                [0, -25.296],
                                                [0, 0],
                                                [-12.827, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-12.982, -5.299],
                                                [0, 0],
                                                [-9.674, 7.454],
                                                [0, 0],
                                                [0, 15.238],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [43.377, 37.102],
                                                [70.931, 8.7],
                                                [70.931, 8.7],
                                                [25.129, -37.102],
                                                [25.129, -37.102],
                                                [-10.912, -26.19],
                                                [-10.912, -26.19],
                                                [-16.679, -28.543],
                                                [-55.588, -23.279],
                                                [-55.588, -23.279],
                                                [-70.931, 7.91],
                                                [-70.931, 8.7],
                                                [-43.867, 37.071]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.129, 0.345, 0.875, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('highlight')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [255.038, 151.655], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 6,
                                        "s": [255.038, 151.655],
                                        "to": [48, 0],
                                        "ti": [-48, 0]
                                    },
                                    { "t": 24, "s": [543.038, 151.655] }
                                ],
                                "ix": 2
                            },
                            "a": { "a": 0, "k": [255.038, 151.655], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.564], "y": [1] },
                                        "o": { "x": [0.204], "y": [0] },
                                        "t": 6,
                                        "s": [0]
                                    },
                                    {
                                        "i": { "x": [0.843], "y": [1] },
                                        "o": { "x": [0.336], "y": [0] },
                                        "t": 11,
                                        "s": [-7]
                                    },
                                    { "t": 24, "s": [0] }
                                ],
                                "ix": 6
                            },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 37,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 37,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
